import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class StockResarvationInventoryItemsService extends BaseApiTemplateService<any> {
  readonly base_url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX;

//https://api.akaun.cloud/core2/tnt/dm/erp/inv/stock-availability/get-qty-with-batch/f66ed26b-62b3-53f7-0923-5e7734c04f2f/backoffice-ep
// the guid here is refereing to the location_guid

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.base_url + "inv/stock-availability/get-qty-with-batch";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "inv/stock-availability/get-qty-with-batch";
    this.httpClient = http;
  }

  public getStockAvailability(inventoryLocationGuid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      url = `${this.apiUrl}/${inventoryLocationGuid}/backoffice-ep`;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }
}